import React from 'react';
import { getLabel } from 'utils/getLabel';
import { map, get } from 'lodash';

// local dependencies
import { Icon } from 'modules/icon-bank';
import { withNetworkState } from 'ui/hoc/withNetworkState';


// success view
export const memberDetailsPayBalanceWidgetSuccess = ( props ) => {

    return(
        <div className='ui-member-detail-section'>
            {
                map( props.cards, ( card ) => {
                    return (
                        <div onClick={ () => props.onActionClick( { value: card } ) } key={ card.name } className="ui-member-detail-section__card" id={ 'ui-member-detail-section__card__' + card.name}  >
                            <div className="ui-member-detail-section__card__info">
                                
                                {/* card name */}
                                <p className="ui-member-detail-section__card__info__title">
                                    { getLabel( card.title ) }
                                </p>

                                {/* card amount */}
                                <p className="ui-member-detail-section__card__info__amount">
                                    ${ get( props, `balanceAndSavings.${[ card.name ]}`, [] ) }
                                </p>
                            </div>
                            
                            <div className="ui-member-detail-section__card__icon" >
                                {/* icon */}
                                <Icon name={ card.name } />
                            </div>
                        </div>
                    );
                } )
            }
        </div>
    );
};

// set display name
memberDetailsPayBalanceWidgetSuccess.displayName = 'memberDetailsPayBalanceWidgetSuccess';

// set default props
memberDetailsPayBalanceWidgetSuccess.defaultProps = {
    title: null,
    state: null,
    cards: [],
};

// prop types
memberDetailsPayBalanceWidgetSuccess.propTypes = {};

/***************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component preloader.
 * @example
 * import { memberDetailsSavingsWidgetPreloader as MemberDetailsSavingsWidgetPreloader } from 'ui/views/widgets/memberDetailsSavingsWidget';
 *
 * // render
 * <memberDetailsSavingsWidgetPreloader propName='propValue'/>
 */
const memberDetailsPayBalanceWidgetPreloader = ( ) => {
    return (
        <div className='ui-member-details-header-widget-preloader__savings'>
            <div className='ui-member-details-header-widget-preloader__savings__name'>
            </div>
            <div className='ui-member-details-header-widget-preloader__savings__details'>
                <div className='ui-member-details-header-widget-preloader__savings__details__specific'>
                    <p className='ui-member-details-header-widget-preloader__savings__details__specific__title__preloader'></p>
                </div>
                <div className='ui-member-details-header-widget-preloader__savings__details__specific'>
                    <div className='ui-member-details-header-widget-preloader__savings__details__specific__icon__preloader'></div>
                </div>
            </div>
        </div>
    );
};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberDetailsSavingsAndBalance as MemberDetailSavingsAndBalance } from 'ui/views/widgets/memberDetailsSavingsAndBalance';
 *
 * // render
 * <MemberDetailSavingsAndBalance propName='propValue'/>
 */
export const memberDetailsPayBalanceWidget = withNetworkState( memberDetailsPayBalanceWidgetPreloader, memberDetailsPayBalanceWidgetSuccess );
